export type SessionNotificationsAction = StaticSessionModified | DynamicSessionModified | EssentialSessionModified;

export interface StaticSessionModified {
  type: 'STATIC_SESSION_MODIFIED';
  tabId: string;
  negotiationId: string;
}

export function staticSessionModified(tabId: string, negotiationId: string): StaticSessionModified {
  return {
    type: 'STATIC_SESSION_MODIFIED',
    tabId,
    negotiationId,
  };
}

export interface DynamicSessionModified {
  type: 'DYNAMIC_SESSION_MODIFIED';
  tabId: string;
  negotiationId: string;
}

export function dynamicSessionModified(tabId: string, negotiationId: string): DynamicSessionModified {
  return {
    type: 'DYNAMIC_SESSION_MODIFIED',
    tabId,
    negotiationId,
  };
}

export interface EssentialSessionModified {
  type: 'ESSENTIAL_SESSION_MODIFIED';
  tabId: string;
  negotiationId: string;
}

export function essentialSessionModified(tabId: string, negotiationId: string): EssentialSessionModified {
  return {
    type: 'ESSENTIAL_SESSION_MODIFIED',
    tabId,
    negotiationId,
  };
}
